// Module
var code = "<a ng-href=\"{{$ctrl.href}}\"\n   title=\"{{$ctrl.title | translate}}\"\n   class=\"vui-main-menu-item tw-block tw-h-5\"\n   ng-disabled=\"$ctrl.disabled\"\n   ng-transclude></a>";
// Exports
module.exports = code;